import gql from 'graphql-tag';
import { AccountCustomer } from '../../__generated__/pge-types';
import { useQuery } from '@apollo/react-hooks';

export const getAccountInfo = gql`
  query getAccountInfo($params: GetAccountInfoParams) {
    getAccountInfo(params: $params) {
      personName
      encryptedPersonId
      personId      
    }
  }
`;

export const useServiceProviderInfo = () => {
  
  const { data: accountInfo,loading: accountInfoLoading } = useQuery<{
    getAccountInfo: AccountCustomer;
  }>(getAccountInfo, {
    context: {
      invoicePayment: true,
    },
    errorPolicy: 'all',
  });

  return {
    personName: accountInfo?.getAccountInfo?.personName || '',
    encryptedPersonId: accountInfo?.getAccountInfo?.encryptedPersonId,
    personId: accountInfo?.getAccountInfo?.personId,
    accountInfoLoading
  };
};
